import { useState } from "react";
import { Box, IconButton, Popover, Tooltip, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/InfoOutlined";

import JsonMonaco from "../../../components/dashboardSchemaEditor/JsonMonaco";

const EXEMPLO = `{
  "overview": {
    "trafficIn":  ["Tráfego de Entrada na Interface", "Tráfego de Entrada"],
    "trafficOut": ["Tráfego de Saída na Interface", "Tráfego de Saída"],
    "latency":    ["Tempo de resposta PING"]
  },
  "health": {
    "cpuUsage": ["CPU Utilizada em Porcentagem"],
    "ramUsage": ["Memória Utilizada em Porcentagem"]
  }
}`;

export default function SchemaHelpPopover({ catalogoAbas = [] }) {
    const [anchorEl, setAnchorEl] = useState(null);

    return (
        <>
            <Tooltip title="Como preencher o schema">
                <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
                    <InfoIcon fontSize="small" color="primary" />
                </IconButton>
            </Tooltip>

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                slotProps={{ paper: { sx: { p: 2, maxWidth: 520 } } }}
            >
                <Typography variant="subtitle1" color="primary" gutterBottom>
                    Como preencher o schema
                </Typography>

                <Typography variant="body2" sx={{ mb: 1 }}>
                    Cada <strong>aba</strong> do formulário é uma{" "}
                    <strong>aba/tela</strong> exibida no sistema do cliente:
                </Typography>

                <Box
                    component="ul"
                    sx={{ pl: 2, mb: 1.5, "& li": { fontSize: 13, lineHeight: 1.6 } }}
                >
                    {catalogoAbas.length === 0 && (
                        <li>
                            <em>Catálogo de abas vazio.</em>
                        </li>
                    )}
                    {catalogoAbas.map((aba) => (
                        <li key={aba.id || aba.key}>
                            {aba.label} — <code>{aba.key}</code>
                        </li>
                    ))}
                </Box>

                <Typography variant="body2" sx={{ mb: 1 }}>
                    Dentro de cada aba, uma <strong>métrica</strong> (ex.:{" "}
                    <code>cpuUsage</code>) recebe os <strong>nomes dos itens</strong>{" "}
                    exatamente como estão mapeados no <strong>Zabbix</strong>. Cada item
                    válido gera automaticamente um componente de gráfico correspondente
                    na interface.
                </Typography>

                <Typography variant="body2" sx={{ mb: 1 }}>
                    Os nomes são comparados <strong>exatamente</strong>: acento e
                    maiúscula importam. As métricas ficam salvas num catálogo e são
                    reaproveitáveis entre modelos.
                </Typography>

                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: "block", mb: 0.5 }}
                >
                    O objeto gerado tem esta forma:
                </Typography>

                <JsonMonaco value={EXEMPLO} readOnly height={220} />

                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: "block", mt: 1.5 }}
                >
                    Uma propriedade <code>_version</code> é adicionada e incrementada
                    automaticamente pelo servidor a cada alteração salva. A ordem das
                    métricas é a ordem dos gráficos, então reordenar conta como
                    alteração.
                </Typography>
            </Popover>
        </>
    );
}
